<template>
  <div class="panel panel-default" id="el">
    <div class="panel-heading">
      <h5 class="panel-title">
        <a data-toggle="collapse" data-target="#collapseMap">{{ title }}</a>
      </h5>
    </div>
    <div id="collapseMap" class="panel-collapse collapse in">
      <div class="panel-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel-heading a:after {
  font-family:'Glyphicons Halflings';
  content:"\e114";
  float: right;
  color: grey;
}
.panel-heading a.collapsed:after {
  content:"\e080";
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// BootstrapPanel.vue?62a819c8